import { useSelector } from "react-redux";
import { selectCurrentToken } from "../features/auth/authSlice";
import jwtDecode from "jwt-decode";

const useAuth = () => {
  const token = useSelector(selectCurrentToken);
  let isEmployee = false;
  let isManager = false;
  let isAdmin = false;
  let status = "Employee";
  let isValidated = false;

  if (token) {
    const decoded = jwtDecode(token);
    // console.log(decoded);
    const { id, name, roles, userRole, company, isValidated, companyType } =
      decoded.UserInfo;

    isEmployee = roles?.includes("Employee");
    isManager = roles?.includes("Manager");
    isAdmin = roles?.includes("Admin");

    if (isEmployee) status = "Employee";
    if (isManager) status = "Manager";
    if (isAdmin) status = "Admin";

    return {
      id,
      name,
      roles,
      accessToken: token, // Add the token for auth purposes
      userRole,
      status,
      isEmployee,
      isManager,
      isAdmin,
      company,
      isValidated,
      companyType,
    };
  }

  return {
    id: "",
    name: "",
    roles: [],
    userRole: "",
    isEmployee,
    isManager,
    isAdmin,
    status,
    company: "",
    isValidated,
    companyType: "",
    accessToken: null, // Include the token field even when not logged in
  };
};
export default useAuth;
